import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: "/", component: Home },
    {
      path: "/client",
      name: "client",
      component: () => import("./views/Client.vue"),
    }, 
    {
      path: "/client/:_name",
      name: "home",
      component: () => import("./views/Home.vue"),
    }, 
    {
      path: "/logs",
      name: "logs",
      component: () => import("./views/Logs.vue"),
    },
  ],
});

export default router;
